<template>
    <footer class="footer"
            :class="{[`footer-${type}`]: type}"
            :data-background-color="backgroundColor">
        <div class="container">
            <nav>
                <ul>
                    <li v-if="activo('nosotros')==true">
                      <router-link v-popover:popover1 class="navbar-brand" to="/nosotros">
                        {{mensaje('nosotros')}}
                      </router-link>
                    </li><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-100%,-20%); line-height: normal; width: 170px;">[general.json->array[0]:nombre=nosotros]</span>
                    <li v-if="mensaje('menCookiesActivo')==true">
                      <router-link v-popover:popover1 class="navbar-brand" to="/cookies">
                         {{mensaje('menCookiesTitulo')}}
                      </router-link>
                    </li><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-100%,-20%); line-height: normal; width: 170px;">[general.json->array[0]:nombre=menCookiesTitulo]</span>
                    <li v-if="mensaje('menDatosActivo')==true">
                      <router-link v-popover:popover1 class="navbar-brand" to="/proteccion">
                          {{mensaje('menDatosTitulo')}}
                      </router-link>
                    </li><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-100%,100%); line-height: normal; width: 170px;">[general.json->array[0]:nombre=menDatosTitulo]</span>
                    <li v-if="mensaje('menTerminosActivo')==true">
                      <router-link v-popover:popover1 class="navbar-brand" to="/terminos">
                          {{mensaje('menTerminosTitulo')}}
                      </router-link>
                    </li><span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(-120%,-20%); line-height: normal; width: 200px;">[general.json->array[0]:nombre=menTerminosTitulo]</span>
                </ul>
            </nav>
            <div class="copyright" style="padding-top: 10px;">
                &copy; {{year}}, Desarrollado por
                <a href="https:///allboxmanager.com" target="_blank">AllBox Manager</a> para
                <a :href="rutaCli" target="_blank">{{cliNom}}</a>
                v.{{$store.state.allbox_web_version}}
                <span v-if="entorno=='development'">w.{{screenWidth}}</span>
            </div>
        </div>
    </footer>
</template>
<script>
  import {RUTA_BASE} from '@/constants'

  import axios from "axios"
  export default {
    props: {
      backgroundColor: String,
      type: String
    },
    data(){
      return {
        id: "0",
        mensajes: [],
        year: new Date().getFullYear(),
        entorno: '',
        screenWidth: 0,
        cliNom: '',
        rutaCli: '',
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.updateScreenWidth);
    },
    mounted() {
      var vid = parseInt(this.id)
      this.entorno = process.env.NODE_ENV
      this.screenWidth = window.innerWidth;
      this.cliNom = this.$store.state.cliente_nombre
      this.rutaCli = this.$store.state.ruta_web_cliente
      window.addEventListener('resize', this.updateScreenWidth);
      var numIdioma = this.$store.state.idiomas[this.$store.state.idioma]
      var cadJson = 'json/general'+numIdioma.toString()+'.json'
      axios.get(RUTA_BASE+cadJson)
      .then(response => {
          this.mensajes = response.data.array[vid].mensajes
      })
      .catch(error => console.log(error))
    },
    watch: {
      '$store.state.idioma': {
        handler(newValue, oldValue) {
          // Acciones a realizar cuando la variable cambia
          console.log('La variable ha cambiado', newValue)
          this.cambiaIdioma(newValue)
        },
        deep: true, // Opcional: vigila cambios profundos en la variable
      },
    },
    methods: {
      cambiaIdioma(nuevoValor) {
        var numIdioma = this.$store.state.idiomas[nuevoValor]
        var cadJson = 'json/general'+numIdioma.toString()+'.json'
        axios.get(RUTA_BASE+cadJson)
        .then(response => {
            this.mensajes = response.data.array[0].mensajes
        })
        .catch(error => console.log(error))
      },
      updateScreenWidth() {
        this.screenWidth = window.innerWidth;
      },
      mensaje(nom) {
        var mens = ''
        this.mensajes.forEach(elemento => {
          if (elemento.nombre==nom) {
            mens = elemento.mensaje
          }
        })
        return(mens)
      },
      activo(nom) {
        var activo = false
        this.mensajes.forEach(elemento => {
          if (elemento.nombre==nom) {
            activo = elemento.activo
          }
        })
        return(activo)
      }
      
    }
  }
</script>
<style>
</style>
